import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { useRoutes } from '../context/RoutesProvider';
import TenancyStatusRedirector from '../auth/components/TenancyStatusRedirector';

export const AppRoutes = () => {
  const { routes } = useRoutes();

  return (
    <Router>
      <TenancyStatusRedirector />
      <Routes>
        {routes.map((route, index) => {
          const { path, element } = route;
          return <Route key={index} path={path} element={element} />;
        })}
      </Routes>
    </Router>
  );
};
